import React, { createContext, useReducer, useEffect } from 'react';
import { State } from 'types';
import { reducer } from './reducer';
import { initialState } from './initialState';
import { Action } from './actions';
import { useEnv } from 'hooks';
import { setSessionStorage } from '../utils';

export type Dispatch = (action: Action) => void;
export type ContextValue = {
  state: State;
  dispatch: Dispatch;
};

export const Context = createContext<ContextValue>({
  state: initialState,
  dispatch: () => null,
});

export interface ContextProps {
  children: React.ReactNode;
  state?: Partial<State>;
}

export const ContextProvider: React.FC<ContextProps> = (props) => {
  const getEnv = useEnv();
  const { children } = props;
  const [state, dispatch] = useReducer(reducer, {
    ...initialState,
    ...props.state,
  });

  useEffect(() => {
    if (getEnv('REACT_APP_ENV') === 'dev') {
      setSessionStorage('state', state);
    }
  }, [state, getEnv]);

  return (
    <Context.Provider
      children={children}
      value={{
        state,
        dispatch,
      }}
    />
  );
};
